<template>
    <div class="my_table" :style="{width:table_style['table_width'],}" >
         <div class="table-head">
             <div  :style="{width:table_style['head_title_width']}" class="head_title">
                 题头
             </div>
             
             <div class="head_content">
                PB(i)
             </div>
             
         </div>
         <dv-decoration-2 :reverse="true" class="line-v" :style="{width:'5px',left:table_style['head_title_width']}" />
         <dv-decoration-10 class="line-h" style="height:5px;" />
         <div class="table-content">
             <div class="row-title" :style="{width:table_style['head_title_width']}">
                 <div v-for="(v,k,i) in data"
                    :key = "i"
                    :style="{height:table_style['grid_height'],width:table_style['head_title_width']}"
                 >
                    {{k}}
                 </div>
             </div>
             <div class="row-content">
                 <!-- <array-table :data="array_data" :cell_width="'15px'"></array-table> -->
                 <table style="width:100%;height:100%;text-align:center">
                     <tr v-for="v,i in data"
                        :key ="i"
                        :style="{height:table_style['grid_height']}"

                     >
                         <td
                            v-for="d,idx in v"
                            :key="idx"
                            :style="{width:table_style['grid_width']}"

                         >{{d}}</td>

                     </tr>
                 </table>
             </div>
         </div>


         
    </div>
</template>

<script> 
import ArrayTable from './com/ArrayTable.vue';

export default {
    name:"MyTable",
    props:{
        table_style:Object,
        data:Object,
        title:String,
        src:String,
        head:String
    },
    data(){
        return {
            // data:{
            //     'x':[1,1,0,0,1,1,1,1],
            //     'y':[1,1,0,0,1,1,1,1],
            //     'z':[1,1,0,0,1,1,1,1],
            // },
          
        }
    },
    computed:{
        table_width(){
            //console.log(this.table_style)
            return this.table_style['table_width'] || '90%'
            // return  '90%'
        },
        table_height(){
            return table_style['table_height'] || '90%'
        },
        head_width(){
             
        },
        array_data(){
            let res = [];
            // this.data.map((v)=>res.push(v));
            for(let i in this.data){
                res.push(this.data[i]);
            }
            return res;
        }
    },
    components:{
        ArrayTable,
    }

}
</script>

<style lang="stylus" scope>

.line-v
    position:absolute;
    top:0px;
    left:40px;
    width:5px;
    height:100%;
    
.line-h
    position:absolute;
    top:30px;
    width:100%;
    height:5px;

.my_table
    position:relative;
    width:95%;
    color:white;
    border:1px solid white;

    //  div
    //     text-align:center;
    //     vertical-align:center;

    .table-head
        height:30px;
        .head_title
            display:inline-block;
            vertical-align :middle;
            text-align :center;
            height:100%;
            //width:40px;

        .head_content
            height:100%;
            display:inline-block;
        
    .table-content
        display:flex;
        width:100%;
        white-space:nowrap;

        .row-title
            display:inline-block;
            height:100%;
        .row-content
            flex:1;
            display:inline-block;
            

 

 


    
</style>
